/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Groupings for the settings in the Documents service
 */
export enum EnumDocumentSettingGroups {
    /**
     * No group
     */
    NotDefined = 0,
    /**
     * Settings for accounting exports
     */
    AccountingExport = 1,
}
